module.exports = __webpack_public_path__ + "static/rocks-c8407f134befb2ed9222dd13d9119658.jpg";